// react
import React from 'react';

// styled-components
import { ThemeProvider } from 'styled-components';

// theme
import { theme } from '@/theme';

/**
 * ThemeProvider provides a theme to all components within the provider.
 */
const SCThemeProvider = ({ children }: ThemeProviderProps) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

interface ThemeProviderProps {
  children?: React.ReactNode;
}

SCThemeProvider.componentName = 'ThemeProvider';

export default SCThemeProvider;
